<template>
  <span class="uploaded-file">
    <a target="_blank" rel="noopener noreferrer" :href="link">
      <a-icon type="paper-clip" /> {{ title }}
    </a>
    <a-button
      v-if="removable"
      type="link"
      size="small"
      class="ml-16"
      @click="$emit('remove')"
    >
      <a-icon type="close" />
    </a-button>
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.uploaded-file {
  position: relative;

  &::after {
    content: '';
    display: block;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: calc(100% + 16px);
    height: calc(100% + 12px);

    background-color: rgba(black, 0.04);
    border-radius: 12px;
    opacity: 0;
    transition: opacity 0.1s;
  }

  button {
    height: 20px;

    position: relative;
    top: -1px;
    right: 2px;
    opacity: 0;
    z-index: 1;
    transition: opacity 0.1s;
  }

  a {
    position: relative;
    z-index: 1;
  }

  &:hover::after {
    opacity: 1;
  }

  &:hover button {
    opacity: 1;
  }
}
</style>
